/* BEEA SKIN routine quiz: four taps, a device and a week plan, the €20 first-order code.
   The email goes to the Klaviyo list BEEA SKIN (QU2f7Q) with the quiz result; Welcome W1 sends the personal KREDIT20 code.
   The result screen shows no code: it says the personal code is waiting in the inbox (Karlo, 4 Nov 2026; was the placeholder BEEA20, which never worked at checkout). */
(function () {
  'use strict';
  var Q = window.BEEA_QUIZ, B = window.BEEA || {};
  var root = document.getElementById('quiz'), tab = document.getElementById('qTab');
  if (!Q || !root || !tab) return;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var money = function (c) { return window.BEEAcart ? BEEAcart.money(c) : ((c || 0) / 100).toFixed(2) + ' €'; };
  var KEY = 'beeaQuiz';
  var store = function () { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } };
  var save = function (o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} };
  var st = store(), ans = {}, lastFocus = null;

  // what each answer adds to each device; the highest wins, the next one is the pairing
  var W = {
    q1: { fresh: { glam: 3, aura: 2, rems: 1 }, firm: { facegym: 3, aura: 2, rems: 1 }, warm: { rems: 4, aura: 1 }, contour: { sculpta: 4, facegym: 1 },
          blemish: { glam: 4 }, hair: { vita: 9 } },
    q2: { hands: { glam: 2 }, short: { sculpta: 1, facegym: 1, rems: 1, vita: 1 }, full: { aura: 2 } },
    q3: { sens: { glam: 1, sculpta: 1, rems: -1 }, calm: {}, unsure: {} },
    q4: { low: { sculpta: 2, aura: -3, facegym: -1, rems: -1, glam: -1, vita: -1 }, mid: { facegym: 1, glam: 1, rems: 1, vita: 1, aura: -1 }, high: { aura: 2 } }
  };
  var ORDER = ['glam', 'aura', 'rems', 'sculpta', 'facegym', 'vita'];
  function pick() {
    var s = {}; ORDER.forEach(function (d) { s[d] = 0; });
    ['q1', 'q2', 'q3', 'q4'].forEach(function (q) { var m = (W[q] || {})[ans[q]] || {}; for (var d in m) s[d] += m[d]; });
    var ok = ORDER.filter(function (d) { var v = (B.devices || {})[d]; return !v || v.available !== false; });
    if (!ok.length) ok = ORDER;
    ok.sort(function (a, b) { return s[b] - s[a] || ORDER.indexOf(a) - ORDER.indexOf(b); });
    var main = ok[0], pair = null;
    if (ans.q4 === 'high' || ans.q2 === 'full') pair = ((B.reco || {})[main] || []).filter(function (d) { return ok.indexOf(d) >= 0; })[0] || null;
    return { dev: main, pair: pair, sens: ans.q3 === 'sens' };
  }

  function step(n) {
    $$('.qstep', root).forEach(function (x) { x.classList.toggle('on', x.dataset.s === String(n)); });
    var f = $('.qstep.on button, .qstep.on input', root); f && f.focus({ preventScroll: true });
  }
  function open(auto) {
    if (root.classList.contains('on')) return;
    var d = document.getElementById('drawer'); if (auto && d && d.classList.contains('on')) return;
    lastFocus = document.activeElement;
    root.classList.add('on'); root.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('qlock');
    st.seen = 1; save(st); tab.classList.add('show');
    if (st.res) { result(st.res, st.code); step(6); } else step(0);
  }
  function close() {
    root.classList.remove('on'); root.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('qlock');
    lastFocus && lastFocus.focus && lastFocus.focus();
  }

  function weekHTML(dev) {
    var days = String(Q.week[dev] || '').split(' · '), cols = Q.cols[dev] || [];
    return '<div class="qweek">' + days.map(function (d, i) {
      var sp = d.indexOf(' '), a = sp > 0 ? d.slice(0, sp) : d, b = sp > 0 ? d.slice(sp + 1) : '';
      return '<div><b>' + esc(a) + '</b><i style="--c:' + esc(cols[i] || 'var(--gold)') + '"></i><span>' + esc(b) + '</span></div>';
    }).join('') + '</div>';
  }
  function result(r, withCode) {
    var v = (B.devices || {})[r.dev] || {}, p = r.pair ? (B.devices || {})[r.pair] : null, t = Q.t;
    var h = '<div class="eyebrow">' + esc(t.res_eyebrow) + '</div>' +
      '<div class="qdev"><span class="qth" style="background-image:url(' + esc(v.img) + ')"></span><div><h3>' + esc(v.name || r.dev) + '</h3>' +
      '<p class="qfit">' + esc(Q.fit[r.dev]) + '</p><p class="qpr">' + money(v.price) + '</p></div></div>' +
      '<small class="qn">' + esc(t.res_week) + '</small>' + weekHTML(r.dev) +
      (r.sens ? '<p class="qnote">' + esc(r.dev === 'glam' ? t.sens_glam : t.sens_note) + '</p>' : '') +
      '<div class="qcta"><button class="btn btn-dark" type="button" data-qadd="' + esc(r.dev) + '">' + esc(t.add) + '</button>' +
      '<a class="btn btn-line" href="' + esc(v.url || '#') + '">' + esc(t.view) + '</a></div>' +
      (withCode
        ? '<div class="qcode qinbox"><span class="qenv" aria-hidden="true"></span><div><small>' + esc(t.inbox_eyebrow) + '</small><b>' + esc(t.inbox_h) + '</b></div><p>' + esc(t.inbox_p).replace('%email%', '<strong>' + esc(st.mail || t.inbox_you) + '</strong>') + '</p></div>'
        : '<button class="qgetcode" type="button" data-qgo="5">' + esc(t.code_get) + '</button>') +
      (p ? '<div class="qpair"><span class="qth" style="background-image:url(' + esc(p.img) + ')"></span><div><small>' + esc(t.res_pair) + '</small><b>' + esc(p.name) + '</b><span>' + money(p.price) + '</span></div><button type="button" data-qadd="' + esc(r.pair) + '">+</button></div>' : '') +
      '<p class="qsafe">' + esc(t.safety) + '</p><button class="qback" type="button" id="qAgain">' + esc(t.again) + '</button>';
    $('#qRes').innerHTML = h;
    var tt = document.getElementById('qTabT'); tt && (tt.textContent = t.tab_done + ': ' + (v.name || r.dev));
  }
  function finish(withCode) {
    var r = pick(); st.res = r; st.code = withCode || st.code || false; save(st);
    result(r, st.code); step(6);
  }

  tab.addEventListener('click', function () { open(false); });
  // any "Your routine" link on the page opens the quiz here (empty bag, menu, home block, footer); without the quiz it goes to /?quiz=1
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-openquiz]'); if (!q) return;
    e.preventDefault();
    var m = document.getElementById('mnav'), bg = document.querySelector('[data-burger]');
    if (m && !m.hasAttribute('hidden')) { m.setAttribute('hidden', ''); bg && bg.setAttribute('aria-expanded', 'false'); document.documentElement.classList.remove('mlock'); }
    if (window.BEEAcart && document.getElementById('drawer') && document.getElementById('drawer').classList.contains('on')) BEEAcart.close();
    open(false);
  });
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-qclose]')) { close(); return; }
    var go = t.closest('[data-qgo]'); if (go) { step(go.dataset.qgo); return; }
    var o = t.closest('[data-q]');
    if (o) {
      ans[o.dataset.q] = o.dataset.v;
      $$('[data-q="' + o.dataset.q + '"]', root).forEach(function (b) { b.classList.toggle('on', b === o); });
      var n = +o.dataset.q.slice(1); setTimeout(function () { step(n + 1); }, 180); return;
    }
    if (t.closest('#qSkip')) { finish(false); return; }
    if (t.closest('#qAgain')) { ans = {}; st.res = null; save(st); $$('[data-q]', root).forEach(function (b) { b.classList.remove('on'); }); step(1); return; }
    if (t.closest('#qCopy')) {
      var c = Q.code, b2 = t.closest('#qCopy');
      (navigator.clipboard ? navigator.clipboard.writeText(c) : Promise.reject()).then(function () { b2.textContent = Q.t.copied; }, function () {});
      return;
    }
    var ad = t.closest('[data-qadd]');
    if (ad) {
      var d = (B.devices || {})[ad.dataset.qadd]; if (!d || !d.variant || !window.BEEAcart) return;
      close(); BEEAcart.add([{ id: d.variant, quantity: 1 }]).catch(function () {});
    }
  });
  var form = document.getElementById('qForm');
  form && form.addEventListener('submit', function (e) {
    e.preventDefault();
    var m = $('#qMail').value.trim(), c = $('#qCons').checked, er = $('#qErr');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(m)) { er.textContent = Q.t.err_mail; return; }
    if (!c) { er.textContent = Q.t.err_consent; return; }
    er.textContent = '';
    st.mail = m; save(st);
    var r0 = pick();
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=XnQJQh', { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2025-01-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'BEEA quiz', profile: { data: { type: 'profile', attributes: { email: m,
          properties: { quiz_device: r0 && r0.dev || '', quiz_pair: r0 && r0.pair || '', quiz_answers: JSON.stringify(ans), quiz_lang: document.documentElement.lang || '' } } } } },
          relationships: { list: { data: { type: 'list', id: 'QU2f7Q' } } } } }) }).catch(function () {});
    } catch (x) {}
    finish(true);
  });
  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('on')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      var f = $$('.qstep.on button, .qstep.on input, .qstep.on a, .qx', root).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  // the tab appears once the visitor scrolls, so it never sits on the hero or the product gallery at first view
  var showTab = function () { if (window.scrollY > 420 || st.res) tab.classList.add('show'); };
  window.addEventListener('scroll', showTab, { passive: true }); showTab();
  if (st.res) { var v0 = (B.devices || {})[st.res.dev]; var tt0 = document.getElementById('qTabT'); v0 && tt0 && (tt0.textContent = Q.t.tab_done + ': ' + v0.name); }
  // one automatic open per visitor: after about 25 seconds, or when the mouse leaves through the top of the window
  if (!st.seen && !/[?&]noquiz=1/.test(location.search)) {
    var t0 = Date.now();
    setTimeout(function () { open(true); }, 25000);
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0 && Date.now() - t0 > 8000 && !store().seen) open(true); });
  }
  if (/[?&]quiz=1/.test(location.search)) open(false);
})();

/* home newsletter block: the email typed there goes into the quiz (T52) */
(function(){document.addEventListener('submit',function(e){var f=e.target.closest&&e.target.closest('[data-quizmail]');if(!f)return;e.preventDefault();var v=(f.querySelector('input[type=email]')||{}).value||'',q=document.getElementById('qMail');if(q&&v)q.value=v.trim();var o=document.createElement('a');o.setAttribute('data-openquiz','');o.href='#';o.style.display='none';document.body.appendChild(o);o.click();o.remove();});})();
